<template>
  <v-container fluid class="ma-0 pa-0">
    <v-layout>
      <v-flex xs12 sm5 md3>
        <template v-if="showDisplayCaseSelector">
          <div v-if="$vuetify.breakpoint.smAndDown">
            <h3 class="pt-3 title" style="width:250px">{{dat[0].portal_name}}</h3>  
          </div>
          <div v-else >
            <h1 class="pt-3 title" >{{dat[0].portal_name}}</h1>  
          </div>
        <v-select :items="dat"
           item-text="code"
           item-value="code"
           v-model="selected"
           label='Select a Display Case'
           :color="cr.colorName"
           style="min-width:175px"
           return-object @change="displayResults">
				</v-select></template>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 sm12 md12 lg12 xl12>
        <template v-if="showDisplay">
          <displayItem  transition="slide-y-transition" :dat="displayCaseItem" :mapsData="maps"  :railId="railId" :cr="cr" :addSwitch= "s" :issues="listIssues"></displayItem>
        </template>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import Display from './Display'
import {mapGetters} from 'vuex'
export default {
  props: {
    dat: {
      type: Array
    },
    mapsData: {
      type: Array
    },
    railId: {
      type: String
    },
    cr: {
      type: Object
    },
    showButton: {
      type: Boolean
    },
    issues: {
      type: Array
    },
    showDisplayCaseSelector: {
      type: Boolean
    }
  },
  components: {
    displayItem: Display
  },
  data () {
    return {
      selected: '',
      showResults: false,
      displayCaseItem: [],
      maps: [],
      listIssues: [],
      s: false
    }
  },
  computed: {
    ...mapGetters({
      showDisplay: 'showDisplay'
    })
  },
  watch: {
    dat () {
      if (this.maps.length !== 0) {
        this.$store.dispatch('toggleDisplay', false)
      }
    },
    mapsData () {
      if (this.maps.length !== 0 && this.displayCaseItem.length !== 0) {
        this.displayResults()
      }
    }
  },
  methods: {
    displayResults () {
      if (this.displayCaseItem.length === 0) {
        this.displayCaseItem.push(this.selected)
        this.mapsData.forEach(element => {
          if (element.serialCode === this.selected.code) {
            this.maps.push(element)
          }
        })
        this.issues.forEach(i => {
          if (i.code === this.selected.code) {
            this.listIssues.push(i)
          }
        })
        this.$store.dispatch('toggleDisplay', true)
      } else {
        this.displayCaseItem = []
        this.maps = []
        this.listIssues = []
        this.displayCaseItem.push(this.selected)
        this.mapsData.forEach(element => {
          if (element.serialCode === this.selected.code) {
            this.maps.push(element)
          }
        })
        this.issues.forEach(i => {
          if (i.code === this.selected.code) {
            this.listIssues.push(i)
          }
        })
        this.$store.dispatch('toggleDisplay', true)
      }
    },
    showString () {
      let container = document.getElementById('top')
      container.scrollTop = 0
      container.pageYOffset = 0
    },
    onScroll (e) {
      document.documentElement.scrollTop = 0
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/displays/DisplayGrid.vue